import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IPremiumReportingCitiesBaseSubscriptions } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

const defaultFilters = {
  alias: 'prcbs',
  relations: [
    {
      path: 'prcbs.baseSubscription',
      alias: 'bs',
    },
  ],
};

const adminGatewayResourcePath: string = '/client-api/premium_reporting_cities_base_subscriptions';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = defaultFilters;
const defaultGetSingleFilters: IQueryCommandOptions = defaultFilters;
const base = new StoreBaseImplementationV2<IPremiumReportingCitiesBaseSubscriptions>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
